import { gql } from '@apollo/client';

export const GET_TABLE_WIDGET_ANNIVERSARIES = gql`
  query GetTableWidgetAnniversaries($programIds: [String], $activityIds: [String]) {
    vm {
      profileAnniversaries(programIds: $programIds, activityIds: $activityIds) {
          profileId
          firstName
          preferredName
          lastName
          volunteer {
            dateCreated
          }
          userId
      }
    }
  }
`;